/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "0.1.0 nightly 2025-04-30",
    versionChannel: "nightly",
    buildDate: "2025-04-30T00:06:45.748Z",
    commitHash: "dae1de5e4cbc5fc74e1d3918fdc3bdfa0c6ce4cc",
};
